import React from 'react';
import PropTypes from 'prop-types';
import { unflatten } from 'flat';
import WVFormatter from '../../../../../../shared/helpers/WVFormatter';

const FirstConversionDateInList = (props) => {
  const { params } = unflatten(props.record);
  if (params?.dealTerms?.date_of_first_conversion) {
    return (
      <span>{ WVFormatter.getFormattedDate(params.dealTerms.date_of_first_conversion)}</span>
    );
  }
  return '';
};
FirstConversionDateInList.propTypes = {
  record: PropTypes.objectOf(PropTypes.any).isRequired,
};
export default FirstConversionDateInList;
